import { ready, onShopifySectionLoad } from './utils/readyinit';
import { initSwiper, initSwiperMobile, initSwiperDesktop } from './components/swiper';
import initAccordion from './components/accordion';
import initAtcPopup from './components/atc-popup';
import initLazyloadVideo from './utils/lazyloadVideo';
import initHeader from './sections/header/header';
import initCustomDropdowns from './components/custom-dropdowns';
import initMinicart from './components/minicart';
import initCartApi from './components/cart-api';
import initAtcForm from './components/atcForm';
import initScrollToTop from './components/scroll-to-top';
import initBackgroundVideos from './components/background-video';
import initProductCards, { initProductCardsApi } from './components/product-card';
import initTabs from './components/tabs';
import initAgeVerification from './components/age-verification';
import initComparePage from './sections/compare-page';

ready(() => {
  // First: an exception in any later init must not leave the page ungated
  initAgeVerification();
  initCartApi();
  initProductCardsApi();
  initSwiper();
  initSwiperMobile();
  initSwiperDesktop();
  initCustomDropdowns();
  initMinicart();
  initHeader();
  initAccordion();
  initLazyloadVideo();
  initBackgroundVideos();
  initAtcForm();
  initAtcPopup();
  initComparePage();
  initScrollToTop();
  initProductCards();
  initTabs();
});

onShopifySectionLoad(() => {
  initAgeVerification();
  initSwiper();
  initSwiperMobile();
  initSwiperDesktop();
  initCustomDropdowns();
  initHeader();
  initAccordion();
  initLazyloadVideo();
  initBackgroundVideos();
  initMinicart();
  initAtcForm();
  initProductCards();
  initComparePage();
  initScrollToTop();
  initTabs();
});
